<template>
  <div>
    <h2 class="hl-variation-list">
      {{ $t("Set.Item.Description.shutter") }}
    </h2>
    <ul class="default-option-list">
      <template v-for="(item, index) in shutterList">
        <li
          v-bind:key="index"
          @click="changeItem(item.itemnumber, item.alerts)"
          :class="{ match: item.match }"
        >
          <img
            class="thumb"
            :src="
              appUrl +
              '/img/assets/shutters/' +
              index.toLowerCase() +
              '_' +
              item.color.toLowerCase() +
              '.jpg'
            "
            :srcset="
              appUrl +
              '/img/assets/shutters/' +
              index.toLowerCase() +
              '_' +
              item.color.toLowerCase() +
              '@2x.jpg'
            "
            :alt="item.text"
          />
          <p>({{ index }}) {{ item.text }}</p>
        </li>
      </template>
      <li v-if="!all" @click="all = true">
        <img class="thumb" :src="appUrl + '/img/icons/next.svg'" />
        <span>{{ $t("Menu.list.profiles.more") }} &gt;</span>
      </li>
    </ul>
  </div>
</template>

<script>
import Config from "@/vuex/Config";

export default {
  name: "VariationsShutters",
  props: ["possibleItems"],
  data() {
    return {
      appUrl: Config.getters.getAppUrl,
      all: true,
      maxItems: 8,
    };
  },
  updated() {
    this.all = !(Object.keys(this.possibleItems.list).length > this.maxItems);
  },
  methods: {
    changeItem: function (itemnumber, alerts) {
      this.$parent.$parent.changeItem(itemnumber, alerts);
    },
  },
  computed: {
    shutterList: function () {
      let list = {};

      let counter = 0;

      let length = Object.keys(this.possibleItems.list).length;

      let maxItems = length < this.maxItems + 1 ? length : this.maxItems;

      for (let key in this.possibleItems.list) {
        if (this.all === true || counter < maxItems) {
          list[key] = this.possibleItems.list[key];
          counter++;
        }
      }

      return list;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#app {
  h4 {
    font-weight: bold;
    font-size: 1em;
  }

  h4 {
    margin-bottom: 1.5em;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    font-size: 1em;
    text-align: center;

    li {
      display: inline-block;
      margin: 1.5em;
      width: 8em;
      vertical-align: top;
      cursor: pointer;

      span {
        font-size: 1em;
      }
    }

    li.match {
      font-weight: bold;
      background-color: inherit;

      img {
        border: solid 0.2rem $brandGold;
      }
    }
  }
}
</style>
